// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

const CONCURRENCY_LIMIT = 10;

export default async function processInBatches({ items, processItem, onProgress }) {
  const results = { successful: [], failed: [] };
  let completed = 0;

  for (let i = 0; i < items.length; i += CONCURRENCY_LIMIT) {
    const batch = items.slice(i, i + CONCURRENCY_LIMIT);
    const batchResults = await Promise.allSettled(batch.map(processItem));

    batchResults.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        results.successful.push(result.value);
      } else {
        results.failed.push({ item: batch[index], error: result.reason });
      }
      completed++;
      onProgress(completed, items.length);
    });
  }

  return results;
}
